import { IMetricData } from '../../MetricChart/useMetricData';
import { useMemo } from 'react';
import useCacheLlmRawDataEffect, {
  objectToKvPairs,
} from './useCacheLlmRawDataEffect';
import { isNil } from 'lodash';

interface IProps {
  data: IMetricData[][];
  analysisId: string;
}

const useCacheMetricLlmRawDataEffect = ({ analysisId, data }: IProps) => {
  const rawData = useMemo(() => {
    return data
      .map((row) => {
        return row
          .map((value) => {
            const {
              name,
              key,
              basePercents,
              values,
              displayValue,
              percentageChange,
              compareValue,
            } = value;
            const obj: any = {
              key,
              name,
              basePercents: basePercents.join(' '),
              values: values.join(' '),
            };
            if (!isNil(displayValue)) {
              obj.displayValue = displayValue;
            }
            if (!isNil(percentageChange)) {
              obj.percentageChange = percentageChange;
            }
            if (!isNil(compareValue)) {
              obj.compareValue = compareValue;
            }
            return objectToKvPairs(obj);
          })
          .join('\n');
      })
      .join('\n');
  }, [data]);
  useCacheLlmRawDataEffect({ analysisId, rawData });
};

export default useCacheMetricLlmRawDataEffect;
